import React from 'react';
import { useHasPermission } from '../../../services/auth/auth';
import { HeroError } from '../error/heroError';
import { ReactComponent as Svg403 } from './../../../assets/heros/403.svg';

import styles from './requirePermission.module.css';

export const RequirePermission = ({permission = [], children}) => {
    const hasPerm = useHasPermission(permission);

    return hasPerm ?
        {...children}
    :
    <HeroError
        hero={<Svg403 />}
        heading='Access Denied'
        subtitle="It looks like you don't have permission to be here"
    />
}